import { Box, Shimmer, ShimmerText } from '@betterment/samba-react';
import { ParentSize } from '@visx/responsive';

import { PlaceholderPerformanceChart } from '../../../../../../../Shared/components-v2/placeholder-performance-chart/PlaceholderPerformanceChart';

const TITLE_WIDTH = '30%';
const BALANCE_WIDTH = '50%';
const HISTORY_WIDTH = '70%';
const DATE_OPTION_WIDTH = 260;

export const PerformanceLoadingState = () => {
  return (
    <Box css={{ minWidth: '0px' }}>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.300' }}>
        <Box
          aria-label="Loading..."
          role="status"
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'space.100',
            maxWidth: 'container.small',
          }}
        >
          <ShimmerText
            textStyle="text25"
            css={{
              maxWidth: TITLE_WIDTH,
            }}
          />
          <ShimmerText
            textStyle="text300"
            css={{
              maxWidth: BALANCE_WIDTH,
            }}
          />
          <ShimmerText
            textStyle="text25"
            css={{
              maxWidth: HISTORY_WIDTH,
            }}
          />
        </Box>
        <ParentSize>
          {({ width }) => <PlaceholderPerformanceChart width={width} height={200} variant="loading" />}
        </ParentSize>
        <Shimmer css={{ width: DATE_OPTION_WIDTH, height: '25px', alignSelf: 'center' }} />
        <ShimmerText textStyle="text25" css={{ maxWidth: '100%' }} />
      </Box>
    </Box>
  );
};
